import * as React from 'react';
import { formatPartialDate } from 'Utility/date';

import { Container, Item } from '../../../../components/Grid';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistoryRow from 'Components/HistoryRow';
import { isPartialDate } from 'neuro-utils';

const _BPHistory = ({ documents, startEdit }: IOwnProps): React.JSX.Element => (
  <>
    {documents
      //.sort((n1, n2) => n1._cdate - n2._cdate)
      //.sort((n1, n2) => sortPartialDate(n1.date, n2.date))
      .reverse()
      .map(d => (
        <HistoryRow
          headerText={'date' in d && isPartialDate(d.date) ? formatPartialDate(d.date) : ''}
          key={d._id}
          rowButton={<HistoryRowControls document={d} startEdit={startEdit} />}
          controlsMargin={false}
        >
          <Container>
            <Item xs={2}>
              {/* <HistoryRowBasicItem
                    header={<FormattedMessage id={'bp.bp'} />}
                    value={}
                  /> */}
            </Item>
          </Container>
        </HistoryRow>
      ))}
  </>
);

interface IOwnProps {
  documents: IDocumentV2[];
  startEdit: StartEdit;
}

export default _BPHistory;
